import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {sagaActions} from './redux/saga';

const OwnerDashboardGlobalView = () => {
  const dispatch = useDispatch();
  const globalViewData = useSelector((state) => state.dashboard.globalViewData);
  useEffect(() => {
    dispatch({
      type: sagaActions.FETCH_OWNER_DASHBOARD_GLOBAL_VIEW,
      payload: {},
    });
  }, []);

  return (
    <div className="mt-3 d-flex">
      <div className="card p-3 mr-2" style={{width: '15%'}}>
        <div className="mb-2">
          <div className="font-weight-bold"># of Corporates</div>
          <div className="border text-center">
            {globalViewData.totalCorporates}
          </div>
        </div>
        <div>
          <div className="font-weight-bold"># of Facilities</div>
          <div className="border text-center">
            {globalViewData.totalFacilities}
          </div>
        </div>
      </div>
      <div className="card p-3 mr-2" style={{width: '40%'}}>
        <div className="w-50 mb-2">
          <div className="font-weight-bold">Total Emissions (t CO2)</div>
          <div className="border  text-center">{globalViewData.totalCo2}</div>
        </div>
        <div className="d-flex w-100">
          <div className="mr-2">
            <div className="text-wrap font-weight-bold">
              Scope 1 Emissions (t CO2)
            </div>
            <div className="border text-center">
              {globalViewData.totalScope1Co2}
            </div>
          </div>
          <div>
            <div className="text-wrap font-weight-bold">
              Scope 2 Emissions (t CO2)
            </div>
            <div className="border text-center">
              {globalViewData.totalScope2Co2}
            </div>
          </div>
        </div>
      </div>
      <div className="card p-3" style={{width: '40%'}}>
        <div className="w-50 mb-2">
          <div className="font-weight-bold">Energy Consumed Net (MMBtu)</div>
          <div className="border text-center">
            {globalViewData.totalNetEnergyConsumed}
          </div>
        </div>
        <div className="d-flex w-100">
          <div className="mr-2">
            <div className="text-wrap font-weight-bold">
              Energy Consumed (MMBtu)
            </div>
            <div className="border w-50 text-center">
              {globalViewData.totalEnergyConsumed}
            </div>
          </div>
          <div>
            <div className="text-wrap font-weight-bold">
              Energy Produced (MMbtu)
            </div>
            <div className="border w-50 text-center">
              {globalViewData.totalEnergyProduced}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OwnerDashboardGlobalView;
